/* af1c-zoom.js — desktop inline scale-up on hover.
 *
 * Pattern: hover the shirt → whole image scales up 2× with transform-origin
 * anchored to the cursor position. Move cursor → the zoomed shirt tracks
 * the cursor, so any point stays visible. Leave → smooth zoom-out.
 *
 * On click, opens PhotoSwipe fullscreen (same viewer as mobile) for a max
 * hi-res inspection. Mobile is handled entirely by af1c-zoom-mobile.js.
 */
(function () {
  'use strict';

  // Desktop only. On mobile, af1c-zoom-mobile.js owns the interaction.
  if (window.matchMedia('(max-width: 900px)').matches) return;

  var ZOOM = 2.0;                 // hover magnification
  var TRANSITION_MS = 260;        // in/out easing
  var TRANSITION_EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  // Print region: the AF1C graphic sits in the chest area of every mockup.
  // Normalized coordinates over the intrinsic image (not the container).
  // [x1, y1, x2, y2] with 0,0 = top-left. Tight enough to only fire zoom
  // over the graphic itself, generous enough to cover every product.
  var PRINT_REGION = { x1: 0.28, y1: 0.22, x2: 0.72, y2: 0.58 };

  function overPrint(px, py) {
    return px >= PRINT_REGION.x1 && px <= PRINT_REGION.x2
        && py >= PRINT_REGION.y1 && py <= PRINT_REGION.y2;
  }

  function attach(img) {
    if (!img || img.__af1cHoverZoomAttached) return;
    img.__af1cHoverZoomAttached = true;

    img.style.transition =
      'transform ' + TRANSITION_MS + 'ms ' + TRANSITION_EASE;
    img.style.willChange = 'transform';
    // Cursor is set dynamically by mousemove: zoom-in over print, default over shirt.
    // Ensure the parent clips the scaled-up image so it doesn't spill onto
    // neighboring layout. hero-main is already relative + centered.
    var parent = img.parentElement;
    if (parent && getComputedStyle(parent).overflow === 'visible') {
      parent.style.overflow = 'hidden';
    }

    var zoomed = false;

    function apply(px, py) {
      px = Math.max(0, Math.min(1, px));
      py = Math.max(0, Math.min(1, py));
      img.style.transformOrigin = (px * 100).toFixed(2) + '% ' + (py * 100).toFixed(2) + '%';
      img.style.transform = 'scale(' + ZOOM + ')';
      zoomed = true;
    }

    function reset() {
      if (!zoomed) return;
      img.style.transform = '';
      img.style.transformOrigin = '50% 50%';
      zoomed = false;
    }

    // Compute cursor position over the rendered image bounds (object-fit:
    // contain aware) so PRINT_REGION coords line up with the actual image.
    function imageCoords(e) {
      var container = img.getBoundingClientRect();
      var iw = img.naturalWidth  || container.width;
      var ih = img.naturalHeight || container.height;
      var imgAspect = (iw && ih) ? (iw / ih) : 1;
      var contAspect = container.width / container.height;
      var rW, rH, oX, oY;
      if (imgAspect > contAspect) {
        rW = container.width; rH = rW / imgAspect;
        oX = 0; oY = (container.height - rH) / 2;
      } else {
        rH = container.height; rW = rH * imgAspect;
        oY = 0; oX = (container.width - rW) / 2;
      }
      // Cursor relative to the rendered image box.
      var ix = (e.clientX - container.left - oX) / rW;
      var iy = (e.clientY - container.top  - oY) / rH;
      // Also cursor relative to the whole container (for transform-origin,
      // which operates on the element box).
      var cx = (e.clientX - container.left) / container.width;
      var cy = (e.clientY - container.top)  / container.height;
      return { ix: ix, iy: iy, cx: cx, cy: cy };
    }

    img.addEventListener('mousemove', function (e) {
      var c = imageCoords(e);
      if (overPrint(c.ix, c.iy)) {
        img.style.cursor = 'zoom-in';
        apply(c.cx, c.cy);
      } else {
        img.style.cursor = 'default';
        reset();
      }
    });

    img.addEventListener('mouseleave', function () {
      reset();
      img.style.cursor = 'default';
    });

    // No click-to-fullscreen — hover scale-up provides full zoom on desktop.
  }

  function init() {
    var hero = document.getElementById('hero-img');
    if (hero) attach(hero);
    var mo = new MutationObserver(function () {
      var h = document.getElementById('hero-img');
      if (h && !h.__af1cHoverZoomAttached) attach(h);
    });
    mo.observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
